import { useMemo } from 'react';
import { createStaticDataProvider } from '@adv-frontend/data-provider';
import { createFilterSelectWithSuggest, HighlightedText } from '@adv-frontend/filters';
import { trimAndLowerString } from '#shared/lib/string';
import { useGetProductWarehouses } from '../../api/api';
import { WAREHOUSES_FILTER_ID, WAREHOUSES_FILTER_TITLE } from '../../constants';
import { useFilterTitleByValue } from '../hooks/useFilterTitleByValue';

type WarehouseData = {
    id: string;
    label: string;
};

export const createWarehousesFilter = () => {
    const slug = WAREHOUSES_FILTER_ID;
    const title = WAREHOUSES_FILTER_TITLE;

    return createFilterSelectWithSuggest<string, WarehouseData>({
        id: slug,
        title,
        suggestProps: {
            dataProvider: function Component(props) {
                const searchString = trimAndLowerString(props.queryArg.searchValue);

                const { data } = useGetProductWarehouses();

                const mappedData = useMemo(
                    () =>
                        (data || [])
                            .filter(({ warehouse_title }) => trimAndLowerString(warehouse_title).includes(searchString))
                            .map(({ warehouse_slug, warehouse_title }) => {
                                return {
                                    id: warehouse_slug,
                                    label: warehouse_title,
                                };
                            }),
                    [data, searchString]
                );

                const dataProvider = useMemo(() => createStaticDataProvider(mappedData), [mappedData]);

                return props.children(dataProvider);
            },
            useTitleByValue: useFilterTitleByValue,
            renderSelectListItem: ({ item, search }) => <HighlightedText text={item.label} search={search} joinParts />,
            renderFilterChipsItem: ({ item }) => item.label,
        },
    });
};
